import { Action, Dispatch } from 'redux'
import { initSchedulesAction } from 'reducks/schedule/actions'

const initSchedules = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initSchedulesAction())
  }
}

export default initSchedules
